require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-eisenstadt-und-umgebung-hornstein.json") })
        }
      }, "path---betreuungseinrichtungen-eisenstadt-und-umgebung-hornstein");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-eisenstadt-und-umgebung-hornstein!./.cache/json/betreuungseinrichtungen-eisenstadt-und-umgebung-hornstein.json
// module id = 859
// module chunks = 231608221292675